var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	688578: {
		fallback: () => (() => (__webpack_require__(480560))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@calendly/feature-check-react",
	},
	642694: {
		fallback: () => (() => (__webpack_require__(147379))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@calendly/i18n",
	},
	347405: {
		fallback: () => (() => (__webpack_require__(440961))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-dom",
	},
	90606: {
		fallback: () => (() => (__webpack_require__(469733))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-redux",
	},
	110171: {
		fallback: () => (() => (__webpack_require__(354625))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react-router-dom",
	},
	141735: {
		fallback: () => (() => (__webpack_require__(296540))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "react",
	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [688578,642694,347405,90606,110171,141735];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"24330": [
		688578,
		642694,
		347405,
		90606,
		110171,
		141735
	],
	"88578": [
		688578
	],
	"92038": [
		688578
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}